import { render, staticRenderFns } from "./VerifyCodeRecord.vue?vue&type=template&id=5f4747b6&"
import script from "./VerifyCodeRecord.vue?vue&type=script&lang=js&"
export * from "./VerifyCodeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports